<div class="tax-category-dialog p-1" data-testid="tax-category-dialog">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.product.tax_categories.fields.tax_code" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <input
        data-testid="tax-category-code-input"
        type="text"
        pInputText
        [(ngModel)]="formData.taxCode"
        [disabled]="isViewMode || isEditMode"
        [placeholder]="'settings.product.tax_categories.placeholders.tax_code' | translate"
        class="w-full"
      />
      @if (showErrors() && !formData.taxCode.trim()) {
        <p class="text-red-500 text-xs mt-1">
          {{ "settings.product.tax_categories.errors.tax_code_required" | translate }}
        </p>
      }
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.product.tax_categories.fields.tax_rate" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-inputNumber
        data-testid="tax-category-rate-input"
        [(ngModel)]="formData.taxRate"
        [disabled]="isViewMode"
        [min]="0"
        [maxFractionDigits]="4"
        suffix="%"
        styleClass="w-full"
        inputStyleClass="w-full"
      ></p-inputNumber>
      @if (showErrors() && (formData.taxRate === null || formData.taxRate < 0)) {
        <p class="text-red-500 text-xs mt-1">
          {{ "settings.product.tax_categories.errors.tax_rate_required" | translate }}
        </p>
      }
    </div>

    <div class="md:col-span-2">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.product.tax_categories.fields.tax_name" | translate }}
      </label>
      <input
        data-testid="tax-category-name-input"
        type="text"
        pInputText
        [(ngModel)]="formData.taxName"
        [disabled]="isViewMode"
        [placeholder]="'settings.product.tax_categories.placeholders.tax_name' | translate"
        class="w-full"
      />
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.product.tax_categories.fields.effective_from" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-datepicker
        data-testid="tax-category-effective-from-input"
        [(ngModel)]="formData.effectiveFrom"
        [disabled]="isViewMode"
        dateFormat="dd/mm/yy"
        appendTo="body"
        styleClass="w-full"
      ></p-datepicker>
      @if (showErrors() && !formData.effectiveFrom) {
        <p class="text-red-500 text-xs mt-1">
          {{ "settings.product.tax_categories.errors.effective_from_required" | translate }}
        </p>
      }
    </div>

    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.product.tax_categories.fields.effective_to" | translate }}
        <span class="text-red-500">*</span>
      </label>
      <p-datepicker
        data-testid="tax-category-effective-to-input"
        [(ngModel)]="formData.effectiveTo"
        [disabled]="isViewMode"
        dateFormat="dd/mm/yy"
        appendTo="body"
        styleClass="w-full"
      ></p-datepicker>
      @if (showErrors() && !formData.effectiveTo) {
        <p class="text-red-500 text-xs mt-1">
          {{ "settings.product.tax_categories.errors.effective_to_required" | translate }}
        </p>
      }
      @if (showErrors() && isInvalidDateRange()) {
        <p class="text-red-500 text-xs mt-1">
          {{ "settings.product.tax_categories.errors.effective_range_invalid" | translate }}
        </p>
      }
    </div>

    <div class="md:col-span-2 flex items-center gap-2">
      <p-checkbox
        data-testid="tax-category-active-checkbox"
        [(ngModel)]="formData.activeFlag"
        [binary]="true"
        [disabled]="isViewMode"
        inputId="taxCategoryActive"
      ></p-checkbox>
      <label for="taxCategoryActive" class="text-sm text-gray-700 cursor-pointer">
        {{ "settings.product.tax_categories.fields.active" | translate }}
      </label>
    </div>

    <div class="md:col-span-2">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        {{ "settings.product.tax_categories.fields.remark" | translate }}
      </label>
      <textarea
        data-testid="tax-category-remark-input"
        pTextarea
        [(ngModel)]="formData.remark"
        [disabled]="isViewMode"
        [rows]="3"
        class="w-full"
      ></textarea>
    </div>
  </div>

  <div class="flex justify-end gap-3 mt-8 pt-4 border-t border-gray-200">
    <app-button
      [testId]="'tax-category-dialog-cancel-btn'"
      [label]="(isViewMode ? 'common.actions.close' : 'common.actions.cancel') | translate"
      type="secondary"
      [outlined]="true"
      (emitOnClick)="onCancel()"
    ></app-button>
    @if (!isViewMode) {
      <app-button
        [testId]="'tax-category-dialog-save-btn'"
        [label]="'common.actions.save' | translate"
        type="info"
        (emitOnClick)="onConfirm()"
      ></app-button>
    }
  </div>
</div>
